<script>
import FriendsList from "@/components/sections/FriendsList.vue";

export default {
  name: "add-friends",

  components: {
    FriendsList,
  }
}
</script>

<template>
  <div>
    <friends-list show-add-friends></friends-list>
  </div>
</template>

<style scoped lang="scss">

</style>